<mat-sidenav-container class="global-sidenav-container" [hasBackdrop]="sidenavService.hasBackdrop">
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
    <mat-sidenav
        #globalSidenav
        position="end"
        [mode]="sidenavService.mode"
        [disableClose]="sidenavService.disableClose"
        [ngStyle]="{
            width: (sidenavService.width || 300) + 'px',
            '--mat-sidenav-container-shape': sidenavService.shape + 'px'
        }"
    >
        <ng-template
            [cdkPortalOutlet]="sidenavService.sidenavPortal | async"
        ></ng-template>
    </mat-sidenav>
</mat-sidenav-container>
